import React from 'react';

import { CLICK_APPLY } from 'externals/_tracking/types/eventTypes.constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { NEGATIVE_MARKS_ACTION } from 'types/morph.pagePosition.constants';
import { useSeenModulePixel } from 'hook/helper.hook';
import GoalNegativeMarksView from './GoalNegativeMarksView';
import { useGoalNegativeMarks } from './hooks/goalNegativeMarks.hook';
import { useSubscriptionLandingUrl } from 'hook/subscriptionLandingUrl.hook';

const GoalNegativeMarksController = props => {
  const atr = getViewModuleTrackingAttributes(
    NEGATIVE_MARKS_ACTION,
    props?.modulePosition,
  );

  const {
    showHideModal,
    showHowItIsCalculated,
    actionPlanSteps,
    delinquentAccounts,
    derogatoryAccounts,
    totalNegativeMarks,
    paymentHistoryGrade,
    potentialPaymentHistoryGrade,
  } = useGoalNegativeMarks(props);
  const { subscriptionLandingUrl } = useSubscriptionLandingUrl();

  const onClickApply = () => {
    props.eventHandler(CLICK_APPLY, {
      'Click Type': 'Apply',
      'Product Offer': props?.offers?.[0]?.id,
      'Product Id': props?.offers?.[0]?.creditRepairId,
    });
  };

  const goBack = () => {
    props?.history?.goBack();
  };

  const seenPixel = useSeenModulePixel(atr);

  return (
    <GoalNegativeMarksView
      {...props}
      goBack={goBack}
      seenPixel={seenPixel}
      onClickApply={onClickApply}
      paymentHistoryGrade={paymentHistoryGrade}
      actionPlanSteps={actionPlanSteps}
      delinquentAccounts={delinquentAccounts}
      derogatoryAccounts={derogatoryAccounts}
      totalNegativeMarks={totalNegativeMarks}
      potentialPaymentHistoryGrade={potentialPaymentHistoryGrade}
      showHideModal={showHideModal}
      showHowItIsCalculated={showHowItIsCalculated}
      subscriptionLandingUrl={subscriptionLandingUrl}
    />
  );
};

export default GoalNegativeMarksController;
